export default "__VITE_ASSET__724900f4__"